import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import ExitToApp from "@material-ui/icons/ExitToApp";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

import link from "api/ui/link";

import urlUtils, { paths } from "utils/url";

import { RequestGroup } from "utils/data";
import { logoutWallet } from "containers/App/WalletWrapper";
import { ADD_NOTIFICATION, LOGOUT_REQUEST } from "../../actions/actionConstants";
import styles from "./header-jss";

class UserMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      openMenu: null,
      userData: {},
    };
  }

  requestGroup = new RequestGroup();

  componentDidMount() {
    this.getUserData();
  }

  handleMenu = (menu) => (event) => {
    const { openMenu } = this.state;
    this.setState({
      openMenu: openMenu === menu ? null : menu,
      anchorEl: event.currentTarget,
    });
  };

  handleClose = () => {
    this.setState({ anchorEl: null, openMenu: null });
  };

  handleGoToProfilePage = () => {
    const { user, history } = this.props;
    history.push(`/my-profile/${user.id}/${user.name}/profile-page`);
    this.setState({ anchorEl: null, openMenu: null });
  };

  getUserData = async () => {
    const { addNotification } = this.props;
    try {
      const userData = await this.requestGroup.getUser();
      this.setState({ userData });
    } catch (err) {
      addNotification(err?.response?.data?.message || "An error occurred");
    }
  };

  render() {
    const { classes, logout, user, userImage } = this.props;
    const { anchorEl, openMenu } = this.state;

    return (
      <div className={classes.infoContainer}>
        <IconButton
          className={classNames(classes.headerIconBtn, classes.scanQrBtn)}
          onClick={() => this.props.history.push(paths?.scanQr)}
          title="Scan QR Code"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            {/* Corner Brackets */}
            <path d="M4 8V4h4" />
            <path d="M16 4h4v4" />
            <path d="M4 16v4h4" />
            <path d="M16 20h4v-4" />

            {/* Finder Patterns (Outline) */}
            <rect x="7" y="7" width="3" height="3" rx="0.5" />
            <rect x="14" y="7" width="3" height="3" rx="0.5" />
            <rect x="7" y="14" width="3" height="3" rx="0.5" />

            {/* Data Dots (Minimal) */}
            <rect x="14" y="14" width="1" height="1" rx="0.2" />
            <rect x="16" y="16" width="1" height="1" rx="0.2" />

            {/* Accent Orange Laser Scanning Line */}
            <line x1="3" y1="12" x2="21" y2="12" stroke="#FF5400" strokeWidth="1.8" />
          </svg>
        </IconButton>
        {this.props.onToggleAiPanel && (
          <IconButton
            className={classNames(
              classes.headerIconBtn,
              classes.aiBtn,
              this.props.aiPanelOpen && classes.aiBtnActive,
            )}
            onClick={this.props.onToggleAiPanel}
            title="AI Command Center"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              {/* Main star (center-left) */}
              <path d="M10 3c0 3.5 2.5 6 6 6-3.5 0-6 2.5-6 6 0-3.5-2.5-6-6-6 3.5 0 6-2.5 6-6z" />
              {/* Secondary star (bottom-right) */}
              <path d="M18 13c0 2 1.5 3.5 3.5 3.5-2 0-3.5 1.5-3.5 3.5 0-2-1.5-3.5-3.5-3.5 2 0 3.5-1.5 3.5-3.5z" />
              {/* Tertiary star (top-right) */}
              <path d="M18 3c0 1.5 1 2.5 2.5 2.5-1.5 0-2.5 1-2.5 2.5 0-1.5-1-2.5-2.5-2.5 1.5 0 2.5-1 2.5-2.5z" />
            </svg>
          </IconButton>
        )}
        <Button
          variant="outlined"
          className={classes.upgradeBtn}
          onClick={() => {
            this.props.history.push("/billing-and-addon");
          }}
        >
          Upgrade
        </Button>
        <Button onClick={this.handleMenu("user-setting")} className={classes.userAvatarBar}>
          <Avatar
            alt={user.name}
            src={userImage ? urlUtils.getProperImageUrl(userImage) : undefined}
            className={classes.avatar}
          >
            {user?.name ? user.name.charAt(0).toUpperCase() : ""}
          </Avatar>
        </Button>
        <Menu
          id="menu-appbar"
          className={classes.userDropdownMenu}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={openMenu === "user-setting"}
          onClose={this.handleClose}
        >
          <MenuItem onClick={this.handleGoToProfilePage} component={Link} to={link.profile}>
            <span>{`${user?.name?.split(" ")?.[0]}'s Profile`}</span>
          </MenuItem>
          <Divider />
          <MenuItem
            onClick={() => {
              logout();
              logoutWallet();
              this.handleClose();
            }}
          >
            <div className={classes.logOutContainer}>
              <span>Log Out</span>
              <ExitToApp />
            </div>
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

UserMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  dark: PropTypes.bool,
  logout: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

UserMenu.defaultProps = {
  dark: false,
};

const mapStateToProps = (state) => ({
  userImage: state.getIn(["users", "user", "info", "image"]),
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch({ type: LOGOUT_REQUEST }),
  addNotification: (message) => dispatch({ type: ADD_NOTIFICATION, message }),
});

const ReduxUserMenu = connect(mapStateToProps, mapDispatchToProps)(UserMenu);

export default withRouter(withStyles(styles)(ReduxUserMenu));
